/**
 * Branded Entra ID login screen.
 *
 * Rebuilt 2026-07-23 to match the Omni ITM (OmniBeta) single-card login: a
 * constellation backdrop with one centred sign-in card. Uses the white BVH
 * logo (the app favicon, /images/BVH_Circle.png) and the "Omni Cloud" name.
 *
 * One click on "Sign in with Microsoft" starts the SSO redirect — there is
 * no silent browser-session probe beforehand (see LoginGate.jsx).
 */

import { useState } from 'react';

function MicrosoftLogo() {
  return (
    <svg className="ms-logo" viewBox="0 0 21 21" width="18" height="18" aria-hidden="true">
      <rect x="0" y="0" width="9.5" height="9.5" fill="#f25022" />
      <rect x="11.5" y="0" width="9.5" height="9.5" fill="#7fba00" />
      <rect x="0" y="11.5" width="9.5" height="9.5" fill="#00a4ef" />
      <rect x="11.5" y="11.5" width="9.5" height="9.5" fill="#ffb900" />
    </svg>
  );
}

export default function LoginPage({ authError, onSignIn }) {
  const [pointer, setPointer] = useState({ x: 50, y: 42 });

  function handleMouseMove(event) {
    setPointer({
      x: (event.clientX / window.innerWidth) * 100,
      y: (event.clientY / window.innerHeight) * 100
    });
  }

  const meshStyle = {
    '--mouse-x': `${pointer.x}%`,
    '--mouse-y': `${pointer.y}%`
  };

  return (
    <section className="login-experience" style={meshStyle} onMouseMove={handleMouseMove}>
      <div className="login-stars" aria-hidden="true" />
      <div className="login-stars login-stars--bright" aria-hidden="true" />
      <div className="login-glow" aria-hidden="true" />

      <article className="login-card">
        <header className="login-brand">
          <span className="login-brand-mark">
            <img src="/images/BVH_Circle.png" alt="Ballyvesey Holdings" />
          </span>
          <span className="login-brand-text">
            <strong>Omni Cloud</strong>
            <span className="login-brand-sub">IT Management</span>
          </span>
        </header>

        <h1 className="login-title">Welcome back</h1>
        <p className="login-lead">
          Sign in with your Microsoft work account to continue to the Omni Cloud admin console.
        </p>

        <button type="button" className="login-ms-button" onClick={() => void onSignIn()}>
          <MicrosoftLogo />
          <span>Sign in with Microsoft</span>
        </button>

        {authError ? <p className="login-error">{authError}</p> : null}

        <div className="login-divider">
          <span>Secure single sign-on</span>
        </div>

        <footer className="login-foot">
          <p>
            Trouble signing in?{' '}
            <a href="mailto:itsupport@ballyvesey.com">Contact IT support</a>
          </p>
          <p>
            <a href="https://status.office.com/" target="_blank" rel="noreferrer">Service status</a>
          </p>
        </footer>
      </article>
    </section>
  );
}
